<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{'modules.clients.associations.associationTariffDialog.title' | translate}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable scroll-content-padding">
    <div class="table-container">
        <mat-table [dataSource]="tariffDataSource" class="dialog-table">

            <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef style="width: 160px; min-width: 160px; max-width: 160px;">{{'modules.clients.associations.associationViewDialog.tables.tariffs.createdAt' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element" style="width: 160px; min-width: 160px; max-width: 160px;">{{element.date | date: 'dd.MM.yyyy HH:mm'}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="author">
                <mat-header-cell *matHeaderCellDef class="fFlex">{{'modules.clients.associations.associationViewDialog.tables.tariffs.author' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="fFlex">{{element.authorName}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="tariff">
                <mat-header-cell *matHeaderCellDef class="fFlex">{{'modules.clients.associations.associationViewDialog.tables.tariffs.tariff' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="fFlex">{{'modules.clients.associations.tariffs.'+element.tariff | translate}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="tariffColumns; sticky: true" class="list-table-header"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tariffColumns" class="list-table-row"></mat-row>
        </mat-table>
    </div>
</div>
